export const FETCH_PROJECT_LIST_BEGIN = 'FETCH_PROJECT_LIST_BEGIN'
export const FETCH_PROJECT_LIST_SUCCESS = 'FETCH_PROJECT_LIST_SUCCESS'
export const FETCH_PROJECT_LIST_FAILED = 'FETCH_PROJECT_LIST_FAILED'

export const FETCH_PROJECT_DETAIL_BEGIN = 'FETCH_PROJECT_DETAIL_BEGIN'
export const FETCH_PROJECT_DETAIL_SUCCESS = 'FETCH_PROJECT_DETAIL_SUCCESS'
export const FETCH_PROJECT_DETAIL_FAILED = 'FETCH_PROJECT_DETAIL_FAILED'
